import { render, staticRenderFns } from "./ItemNewsList.vue?vue&type=template&id=1c154990&"
import script from "./ItemNewsList.vue?vue&type=script&lang=js&"
export * from "./ItemNewsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports